export default __webpack_public_path__ + "static/char-s-41-ja-174fe96f6b1d7e89f72937b61e33929b.webp";